module.exports = __webpack_public_path__ + "media/images/photo-not-available-2a6875c1.jpg";